<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 18/2/2021
  -->

<template>
    <qw-drawer size="100%"
               class="wizard-layout-root"
               :close-on-press-escape="false"
               v-model="showWizard"
               :analytics-props="{title: 'Wizard', ...analyticsPropsMethod()}"
               :show-close-button="false"
               @keyup.esc.native="onCloseClicked"
               @close="onCancel">

		<LoadingIndicator :is-loading="!isLoaded"/>

        <div v-if="isLoaded" class="h-100 w-100 justify-content-center qw-row">

            <div v-if="isVertical" class="row mx-0 h-100 overflow-hidden w-100">
                <div class="wizard-steps-panel overflow-y h-100">
                    <el-steps direction="vertical"
                              :active="activeStep"
                              finish-status="success"
                              process-status="finish"
                              :space="space">
                        <el-step v-for="(step, index) in stepsComputed" :key="index"
                                 :title="step.title"
                                 :description="stepDescription[index]">
                        </el-step>
                    </el-steps>
                </div>
                <div class="col content-panel overflow-y h-100 relative fill-height">
                    <div class="row mx-0 align-items-center pb-5">
                        <StepTitle v-if="activeComponentTitle()">{{ activeComponentTitle() }}</StepTitle>
                        <div class="layout-spacer"></div>
                        <button
                            type="button"
                            class="el-drawer__close-btn"
                            @click="onCloseClicked()">
                            <i class="el-dialog__close el-icon fontello icon-cancel-1"></i>
                        </button>
                    </div>
                    <transition v-if="isLoaded" :name="transitionName" mode="out-in" @enter="onComponentChanged" appear>
                        <keep-alive>
                            <component ref="contentComponent"
                                       :is="activeComponentClass"
                                       :key="activeStep"
                                       :title="getStepTitle()"
                                       :wizardData="wizardData"
									   :viewMode="viewMode"
									   :stepGlobalData="getStepGlobalData()"
                                       :stepIdProp="getCurrentStepId()"
                                       :savedState="onRestoreStateForStep(activeStep)"
                                       :async-handler="handleAsync"
									   v-bind="stepParams(activeStep)"
									   @onRestoreStateFinished="onRestoreStateFinished"
                                       @nextStep="onNextClicked"
                                       @prevStep="onPrevClicked"
                                       @skipStep="onSkipClicked"
                                       @showActionPanel="onShowActionPanel"
                                       @showLoading="onShowLoading"
                            />
                        </keep-alive>
                    </transition>
                    <transition :name="transitionName" mode="out-in">

						<div :key="''+activeStep+'_'+componentChangeCounter">

                        <div class="actions-panel row mx-0" v-if="!hideActionButtons()">
                            <div class="layout-spacer"></div>
							<qw-button v-if="showSaveAndClosePerStep && hasMoreSteps" @click="onFinishClicked" type="success">Save and close</qw-button>
                            <qw-button v-if="canSkipStep()" @click="onSkipClicked" class="pr-4" simple>Skip</qw-button>
                            <qw-button v-if="hasPrevSteps" @click="onPrevClicked">Previous</qw-button>
                            <qw-button v-if="hasMoreSteps" @click="onNextClicked" type="primary">Next</qw-button>
                            <qw-button v-else @click="onFinishClicked" type="success">{{lastStepText}}</qw-button>
                        </div>
						</div>

					</transition>

                    <LoadingIndicator
                        :is-loading="isProgressShowing || !isLoaded"
                        :message="progressText"/>
                </div>
            </div>
			<div v-else class="wizard-horizontal mx-0 w-100">
				<div class="overflow-y relative w-100">
					<div class="pb-5 w-100">
						<div class="row mx-0 align-items-center w-100">
							<StepTitle v-if="title">{{ title }}</StepTitle>
							<div class="layout-spacer"></div>
							<button
								type="button"
								class="el-drawer__close-btn"
								@click="onCloseClicked()">
								<i class="el-dialog__close el-icon fontello icon-cancel-1"></i>
							</button>
						</div>
						<div v-if="description">{{description}}</div>
					</div>

					<div class="w-100 wizard-steps-panel-horizontal">
						<el-steps
								  :active="activeStep"
								  finish-status="success"
								  process-status="finish"
								  align-center>
							<el-step v-for="(step, index) in stepsComputed" :key="index"
									 :title="step.title">
<!--									 :description="stepDescription[index]">-->
							</el-step>
						</el-steps>
					</div>
					<div class="content-panel">
						<transition v-if="isLoaded" :name="transitionName" mode="out-in" @enter="onComponentChanged" appear>
							<keep-alive>
								<component ref="contentComponent"
										   :is="activeComponentClass"
										   :key="activeStep"
										   :title="getStepTitle()"
										   :wizardData="wizardData"
										   :viewMode="viewMode"
										   :stepGlobalData="getStepGlobalData()"
										   :stepIdProp="getCurrentStepId()"
										   :savedState="onRestoreStateForStep(activeStep)"
										   :async-handler="handleAsync"
										   v-bind="stepParams(activeStep)"
										   @onRestoreStateFinished="onRestoreStateFinished"
										   @nextStep="onNextClicked"
										   @prevStep="onPrevClicked"
										   @skipStep="onSkipClicked"
										   @showActionPanel="onShowActionPanel"
										   @showLoading="onShowLoading"
								/>
							</keep-alive>
						</transition>
					</div>
				</div>


				<div>
					<transition :name="transitionName" mode="out-in">

						<div :key="''+activeStep+'_'+componentChangeCounter">

							<div class="actions-panel row mx-0" v-if="!hideActionButtons()">
								<div class="layout-spacer"></div>
								<qw-button v-if="showSaveAndClosePerStep && hasMoreSteps" @click="onFinishClicked" type="success">Save and close</qw-button>
								<qw-button v-if="canSkipStep()" @click="onSkipClicked" class="pr-4" simple>Skip</qw-button>
								<qw-button v-if="hasPrevSteps" @click="onPrevClicked">Previous</qw-button>
								<qw-button v-if="hasMoreSteps" @click="onNextClicked" type="primary">Next</qw-button>
								<qw-button v-else @click="onFinishClicked" type="success">{{lastStepText}}</qw-button>
							</div>
						</div>

					</transition>

					<LoadingIndicator
						:is-loading="isProgressShowing || !isLoaded"
						:message="progressText"/>
				</div>
			</div>
        </div>


    </qw-drawer>


</template>

<script>

import BaseComponent from "@/core/components/BaseComponent.vue";
import BaseWizard from "@/core/components/Wizard/BaseWizard.vue";
import {asBase64, checkExtendsComponent, fromBase64, ViewModeEnum} from "@/utils/helpers";
import QwDrawer from "@/core/components/Form/QwoachDrawer.vue";
import LoadingIndicator from "@/core/components/LoadingIndicator.vue";
import {yesNoDialog} from "@/core/components/Dialogs/dialog";
import StepTitle from "@/core/components/Wizard/StepTitle.vue";
import {DataStorageType} from "@/core/components/Wizard/DataStorageType";
import {plainToClass} from "@qwoach/class-transformer-wrapper";

export default {
    name: "WizardLayout",
    components: {StepTitle, LoadingIndicator, QwDrawer},
    extends: BaseComponent,

    props: {
        space: {Number, String, default: "50px"},
        canSaveState: {Boolean, default: true},
		showSaveAndClosePerStep: Boolean,
		viewMode: ViewModeEnum,
		isVertical: {Boolean, default: true},
		title: String,
		description: String,
    },

	watch:{
		$route (to, from){
			console.log("Wizard layout: $route changed: to = ", to, ", from = ", from)
			if(!to.path.startsWith(from.path) && !from.path.startsWith(to.path)){
				this.closeNavigateAway()
			}
		}
	},

	data() {
        return {
			globalDataId: "step_global_data",
            showWizard: true,
            activeStep: 0,
            transitionName: "slide",
            wizardData: {},
            stepsComputed: [],
            stepDescription: [],
            canShowActionPanel: true,
			isLoaded: false,
			closeNotifyParent: true,
			hasGlobalData: false,
			dataStorageKey: "wzs",
			componentChangeCounter: 0,
        }
    },

    async created() {
		console.log("WizardLayout created")
		await this.setupWizard()
	},

	async mounted() {
        console.log("handleAsync22: this = ", this)
    },


    methods: {


		async setupWizard(){
			this.setupParent()
			await this.handleAsync(this.loadData())
			this.isLoaded = true
		},

		setupParent(){
			let targetComponent = BaseWizard
			if (!checkExtendsComponent(this.$parent, targetComponent)) {
				throw Error(`${this.$options.name} must be placed inside a component that extends ${targetComponent}: found in ${this.$parent.$options.name}`)
			}
			this.$parent.registerLayout(this)
		},

        getWizardData() {
            return this.wizardData
        },

		async setupGlobalData(stateObj){

			if(stateObj && stateObj.data){
				this.wizardData = stateObj.data
			} else {
				let globalData = await this.createWizardGlobalData()
				if(globalData){
					this.wizardData[this.globalDataId] = globalData
				}
			}
			console.log("WizardLayout.setupGlobalData: ", this.wizardData)
			if(this.wizardData[this.globalDataId]){
				this.hasGlobalData = true
			}

		},

		async createWizardGlobalData(){
			return this.$parent.createWizardGlobalData()
		},

        async loadData() {
            await this.restoreState()
            this.stepsComputed = await this.wizardSteps()//await this.handleAsync(() => this.wizardSteps())
			// await this.restoreData()
        },

		// async restoreData(){
		// 	console.log('WizardLayout.restoreData')
		// 	let dataGlobal = this.getStateObjDataForStepIndex(this.globalDataId)
		// 	for(let i = 0; i < this.activeStep; ++i){
		// 		let {stepId, component} = this.stepsComputed[i]
		//
		// 		let stepData = this.getStateObjDataForStepIndex(i)
		// 		console.log("WizardLayout.restoreData: stepData = ", stepData)
		//
		// 		let WizardStepClass = Vue.extend(component)
		// 		console.log("WizardLayout.restoreData: WizardStepClass = ", WizardStepClass, ", component = ", component)
		// 		let wizardStep = new WizardStepClass()
		// 		console.log("WizardLayout.restoreData: wizardStep = ", wizardStep)
		// 		if(stepData){
		// 			await wizardStep.restoreState(stepData)
		// 		}
		// 		if(dataGlobal){
		// 			await wizardStep.restoreStateGlobal(dataGlobal)
		// 		}
		//
		// 		await wizardStep.loadData()
		// 		let data = await wizardStep.getStepData()
		// 		dataGlobal = await wizardStep.saveStepDataGlobal(dataGlobal)
		// 		if(data){
		// 			this.wizardData[stepId] = data
		// 		}
		// 	}
		// 	if(dataGlobal){
		// 		this.wizardData[this.globalDataId] = dataGlobal
		// 	}
		// },

        async handleStep() {
            let component = this.getActiveComponent()
            let isValid = await this.handleAsync(component.validateStep(), component.getProgressText())
			console.log("handleStep: isValid = ", isValid)
			if (!isValid) {
                return false
            }
            let activeComponent = this.getActiveComponent()

			let {data, dataGlobal} = await this.handleAsync(async () => {
				let res = await activeComponent.onNextClicked()
				if(res === false){
					return false
				}
				let data = await activeComponent.getStepData() || res
				console.log("handleStep: activeComponent = ", activeComponent)

				let dataGlobal = this.wizardData[this.globalDataId]
				dataGlobal = await activeComponent.saveStepDataGlobal(dataGlobal)

				return {data: data, dataGlobal: dataGlobal}
			}, activeComponent.getProgressSaveText())
            console.log("handleStep: res = ", data)
            if (data === false) {
                return false
            }
			if(data){
				this.wizardData[component.stepId()] = data
			}
			if(dataGlobal){
				this.wizardData[this.globalDataId] = dataGlobal
			}

            this.setupStepDescription()
            return true
        },

		onRestoreStateFinished(){
			console.log("WizardLayout: current step - onRestoreStateFinished")
		},

        async onNextClicked() {
            let _ = this.$analyticManager.trackEvent("Next step clicked", this.analyticsPropsMethod())
            this.transitionName = "slide"
            let res = await this.handleStep()
            if (res) {
                this.activeStep++
                await this.saveState()
            }
        },

        async onFinishClicked() {
            let _ = this.$analyticManager.trackEvent("Finish wizard clicked", this.analyticsPropsMethod())
            let res = await this.handleStep()
            if (res) {
                await this.onFinishWizard()
            }
        },

        async onPrevClicked() {
            let _ = this.$analyticManager.trackEvent("Previous step clicked", this.analyticsPropsMethod())
            let activeComponent = this.getActiveComponent()
            let res = await this.handleAsync(activeComponent.onPrevClicked(), activeComponent.getProgressText())
            if (res === false) {
                return
            }

            this.transitionName = "slideBack"
            this.activeStep--
        },

        async onCloseClicked() {
            let res = await yesNoDialog({
                title: "Close wizard?",
                message: "Are you sure you want to close this wizard?",
                yesButton: "Yes, close",
            })
            if (res) {
                this.showWizard = false
                this.onCancel()
            }
        },

        getCurrentStepId(stepId = this.activeStep) {

            let step = this.stepsComputed[stepId]
            if (step) {
                return step.stepId
            }
        },

		getStateObjDataForStepIndex(stepIndex){
			let stateObj = this.getStateObject(stepIndex)
			let stepData = null
			if (stateObj && stateObj.data) {
				if(typeof stepIndex === "string"){
					stepData = stateObj.data[stepIndex]
				} else {
					stepData = stateObj.data[this.getCurrentStepId(stepIndex)]
				}
			}
			console.log("WizardLayout.getStateObjDataForStepIndex: stepData = ", stepData, ", stepIndex = ", stepIndex)
			return stepData

		},

		stepParams(stepIndex){
			return this.stepsComputed[stepIndex].params
		},

        onRestoreStateForStep(stepIndex) {
			let stepData = this.getStateObjDataForStepIndex(stepIndex)
            let res = this.$parent.onRestoreStateForStep(stepIndex) || stepData
            console.log("onRestoreStateForStep: stepData = ", stepData, ", res = ", res, ", this.wizardData = ", this.wizardData)
            return res
        },

        async onComponentChanged() {
			console.log("WizardLayout.onComponentChanged")
			//needed to ensure the "refs.contentComponent" is correctly setup since refs are not reactive
            // this.$forceUpdate()
			this.componentChangeCounter++

			await this.$nextTickPromise()
			//don't use handleAsync here as it's also called in the "mount" hook of the step. calling handleAsync twice prevents it from showing up properly.
			// this.handleAsync(this.getActiveComponent().onStepEnteredInternal())
			let _ = this.getActiveComponent().onStepEnteredInternal()
        },

        onShowLoading(canShow, text) {
            if (canShow) {
                this.progressDataLoading(text)
            } else {
                this.hideProgress()
            }
        },

        onShowActionPanel(canShow) {
			console.log("WizardLayout.onShowActionPanel: canShow = ", canShow)
            this.canShowActionPanel = canShow
        },

        async onSkipClicked() {
            let _ = this.$analyticManager.trackEvent("Skip step clicked", this.analyticsPropsMethod())
            let activeComponent = this.getActiveComponent()
            let res = await this.handleAsync(activeComponent.onSkipClicked(), activeComponent.getProgressSaveText())
            if (res === false) {
                return
            }
            this.setupStepDescription()
            this.transitionName = "slide"
            if (this.hasMoreSteps) {
                this.activeStep++
                await this.saveState()
            } else {
                await this.onFinishWizard()
            }
        },

        async onFinishWizard() {
            this.transitionName = "slide"
            return this.onOk()
        },


        async wizardSteps() {
            return this.$parent.wizardSteps()
        },

        setupStepDescription() {
            let activeComponent = this.getActiveComponent()
            this.stepDescription[this.activeStep] = this.stepsComputed[this.activeStep].description || activeComponent.stepDescription()
        },

        $close(data) {
            this.$parent.$close(data)
        },

        $error(data) {
            this.$parent.$error(data)
        },

        async onWizardResult(wizardData) {
			let data = this.hasGlobalData ? wizardData[this.globalDataId] : wizardData
            return this.$parent.onWizardResult(data)
        },

        async onOk() {
            await this.handleAsync(async () => {
                let result = await this.onWizardResult(this.wizardData)
                console.log("WizardLayout onOk: result = ", result)
                return this.$parent.onOk(result)
            }, this.onWizardResultLoadingText())
        },

        onWizardResultLoadingText() {
            if (typeof this.$parent.onWizardResultLoadingText === "function") {
                return this.$parent.onWizardResultLoadingText()
            }
            return "Finishing setup..."
        },

		closeNavigateAway(){
			this.closeNotifyParent = false
			this.showWizard = false
		},

        onCancel() {
			if(this.closeNotifyParent){
				return this.$parent.onCancel()
			}
        },
        onCancel2() {
            return this.$parent.onCancel2()
        },
        onDelete() {
            return this.$parent.onDelete()
        },

        getActiveComponent() {
			console.log("WizardLayout.getActiveComponent: this.$refs.contentComponent = ", this.$refs.contentComponent)
            return this.$refs.contentComponent
        },

        activeComponentTitle() {
            let activeComponent = this.getActiveComponent()
			console.log("WizardLayout.activeComponentTitle: activeComponent = ", activeComponent)

			if (activeComponent) {
                return activeComponent.getTitle()
            }
        },

        hideActionButtons() {
			console.log("WizardLayout.hideActionButtons: this.canShowActionPanel = ", this.canShowActionPanel)
            if (!this.canShowActionPanel) {
                return true
            }
            let activeComponent = this.getActiveComponent()
			console.log("WizardLayout.hideActionButtons: activeComponent = ", activeComponent)
            if (activeComponent) {
                return activeComponent.hideActionButtons()
            }
            return true

        },

        canSkipStep() {
            let activeComponent = this.getActiveComponent()
            console.log("canSkipStep: activeComponent = ", activeComponent)
            if (activeComponent) {
                return !activeComponent.isStepRequired()
            }
            return false
        },

        analyticsPropsInternal() {
            let step = this.stepsComputed ? this.stepsComputed[this.activeStep] : null
            let props = {
                step_index: this.activeStep
            }
            if (step) {
                props.step_title = step.title
            }

            return {
                category: "Wizard",
                ...props
            }
        },

		getDataStorageType(){
			return this.$parent.getDataStorageType()
		},

        async saveState() {
            if (!this.canSaveState) {
                console.log("saveState: canSaveState is false. skipping saving state")
                return
            }
            await this.handleAsync(async () => {
                // let data = await this.onSaveState()
				// if(this.getStepGlobalData()){
				// 	data = data || {}
				// 	data[this.globalDataId] = this.getStepGlobalData()
				// }
				//
                // await this.saveStateData(data)
				await this.saveStateData(this.wizardData)

            })
        },

        async saveStateData(data) {
			let stateObj = this.getStateObject() || {}

			stateObj = {
				...stateObj,
				step: this.activeStep,
				data: {
					...stateObj.data,
					...data
				},
				stepDescription: this.stepDescription
			}

			console.log("WizardLayout saveStateData: stateObj = ", stateObj)

			let value = asBase64(JSON.stringify(stateObj))
			let key = this.dataStorageKey
			await this.saveStateDataInternal(key, value)
        },



		async saveStateDataInternal(key, value) {
			let storageType = this.getDataStorageType()
			switch (storageType){
				case DataStorageType.SESSION_STORAGE:
					await this.saveStateObjectToSessionStorage(key, value)
					break
				case DataStorageType.QUERY:
				default:
					await this.saveStateObjectToQuery(key, value)
			}
		},

		async saveStateObjectToSessionStorage(key, value){
			this.$session.set(key, value)
		},

		async saveStateObjectToQuery(key, value){
			await this.setQuery({[key]: value})
		},



		getStateObject() {
			let stateObj = this.getStateObjectInternal()
			if (stateObj) {
				console.log("WizardLayout getStateObject: stateObj = ", stateObj)
				let decoded = fromBase64(stateObj)
				let object = JSON.parse(decoded)
				object = this.restoreClass(object)
				console.log("WizardLayout getStateObject: object = ", object)
				return object
			}
		},

		restoreClass(object){
			console.log("WizardLayout: restoreClass: ", object)
			let data = object.data || {}
			let globalData = data[this.globalDataId]
			if(globalData){
				let clazz = this.$parent.getGlobalObjectClass()
				if(clazz){
					globalData = plainToClass(clazz, globalData)
					data[this.globalDataId] = globalData
				}
			}
			console.log("WizardLayout: restoreClass result: ", object)
			return object
		},

		getStateObjectFromSessionStorage(){
			return this.$session.get(this.dataStorageKey)
		},


		getStateObjectFromQuery() {
			return this.$route.query[this.dataStorageKey]
		},


		async restoreState() {
            let stateObj = this.getStateObject()

			await this.setupGlobalData(stateObj)

			if (this.canSaveState && stateObj) {
                this.activeStep = stateObj.step
                this.stepDescription = stateObj.stepDescription || []
                await this.onRestoreState(stateObj.data)
            }

		},

        queryParamsToRemoveOnClose() {
            return [this.dataStorageKey]
        },

        async onSaveState() {
            let currentComponent = this.getActiveComponent()
            let res = await currentComponent.saveState()
            if (res) {
                return {[currentComponent.stepId()]: res}
            }
            return res || this.$parent.onSaveState()
        },

        async onRestoreState(data) {
            await this.$parent.onRestoreState(data)
        },

        getStepTitle() {
            let step = this.stepsComputed[this.activeStep]
            console.log("getStepTitle: this.activeStep = ", this.activeStep)
            if (step) {
                return step.title
            }
        },

		getStepGlobalData(){
			return this.wizardData[this.globalDataId]
		},

		getStateObjectInternal() {
			let storageType = this.getDataStorageType()
			switch (storageType){
				case DataStorageType.SESSION_STORAGE:
					return this.getStateObjectFromSessionStorage()
				case DataStorageType.QUERY:
				default:
					return this.getStateObjectFromQuery()
			}
		}
	},

    computed: {

        activeComponentClass() {
            let activeStep = this.stepsComputed[this.activeStep]
            return activeStep ? activeStep.component : null
        },


        hasMoreSteps() {
            return this.activeStep < this.stepsComputed.length - 1
        },
        hasPrevSteps() {
            return this.activeStep > 0
        },

		lastStepText(){
			return this.$parent.lastStepText || "Finish"
		},



	}

}
</script>

<style lang="scss">

@import "@/assets/scss/style/variables";
@import "@/assets/scss/style_v2/style_v2";

.wizard-layout-root {

	.wizard-horizontal{
		.el-step__title{
			font-size: px-to-rem(14);
		}
	}
    .el-drawer__body {
        display: flex;
    }

	.wizard-steps-panel{


		.is-success {
			color: #409EFF;
			border-color: #409EFF;
		}

		//.el-step__head{
		//	border-color: #409EFF;
		//}

		.el-step__icon {
			font-size: 12px;
			color: white;
			background: #409EFF;
		}

		.is-wait {
			.el-step__icon {
				background: #C0C4CC;
			}
		}

		.el-step__title:not(.is-wait) {
			color: white;
		}

		.el-step__description {
			white-space: pre-wrap;
			padding-bottom: 15px;
		}

		.el-step__title.is-finish {
			font-weight: 600;
		}

		.el-step__description:not(.is-wait) {
			//color: $color-text-lightest;
		}


		.steps-light {
			.el-step__title:not(.is-wait) {
				color: $color-title;
			}

			.el-step__description:not(.is-wait) {
				color: $color-title;
			}


		}
	}

	.wizard-horizontal{
		max-width: 800px;
		min-height: 100%;
		padding: 20px;
		margin: 0 auto;

		.content-panel {
			padding: 0;
		}

		.wizard-steps-panel-horizontal{




			.is-success {
				color: $color-primary_v2;
				border-color: $color-primary_v2;
			}

			.el-step__icon {
				font-weight: $weight-medium;
				font-size: 14px;
				color: white;
				background: $color-primary_v2;
				border-color: $color-primary_v2;
			}

			.is-success{
				.is-status {
					svg {
						margin-top: px-to-rem(-5);
					}
				}
			}

			.el-step__line{
				background-color: transparent;
				color: $gray-200_v2;
				border-bottom: none;
				border-top: 1px dashed;
			}

			.el-step__line-inner{
				opacity: 0;
			}

			.is-wait {
				.el-step__icon {
					background: white;
					border-color: $gray-100_v2;
					color: $gray-400_v2;
				}
			}

			.el-step__title {
				color: $gray-400_v2;
				&.is-finish, &.is-success {
					font-weight: $weight-bold;
					color: $color-primary_v2;
				}
			}

			.el-step__description {
				//white-space: pre-wrap;
				//padding-bottom: 15px;
			}

			.el-step__title.is-finish {
				//font-weight: 600;
			}

			.el-step__description:not(.is-wait) {
				//color: $color-text-lightest;
			}
		}



	}


    .wizard-steps-panel {
        min-width: 200px;
        max-width: 350px;
        padding: 20px;
        background: #3A3A3A;
    }

    .content-panel {
        padding: 20px;
    }

    .actions-panel {
        padding: 20px 0 80px 0;
    }
}
</style>
